import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, TextStyle, DisplayText } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { DateTimeFormatter } from '@nile/components';

interface InvoiceItemData {
  invoiceId: string;
  displayId: string;
  createdTime: string;
}

interface InvoicedItemsListProps {
  items: InvoiceItemData[];
}

const InvoicedItemsList: React.FC<InvoicedItemsListProps> = ({ items }) => {
  const ticketContext = useContext(TicketContext);

  const handleInvoiceClick = (invoice: InvoiceItemData) => {
    if (ticketContext?.openTab) {
      ticketContext.openTab({
        module: 'INVOICE',
        data: {
          invoiceId: invoice.invoiceId
        }
      });
    }
  };

  return (
    <div className="flex fx-sb col g15 p20">
      <TextStyle weight="SemiBold">
        <FormattedMessage id="ticket.details.insights.invoicedItems" />
      </TextStyle>

      {items?.length === 0 && (
        <TextStyle variation="subdued">
          <FormattedMessage id="invoice.list.noData.heading" />
        </TextStyle>
      )}

      {items?.length > 0 &&
        items?.map((item) => (
          <div key={item.invoiceId} className="flex actr g8">
            <Button plain onClick={() => handleInvoiceClick(item)}>
              <div className="flex actr g5">
                <div className="fx center">
                  <SVGIcon name="InvoiceLogo" color="#091EF5" />
                </div>
                <TextStyle variation="strong">{item.displayId}</TextStyle>
              </div>
            </Button>
            <DisplayText size="medium">
              <DateTimeFormatter type="dateTime" date={item.createdTime} />
            </DisplayText>
          </div>
        ))}
    </div>
  );
};

export default InvoicedItemsList;
